<!--
//================================================================================
// ID:BC002
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC002
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/16 | 富士通株式会社         | 新規作成
// 01.01.00 | 2022/06/27 | 富士通Japan株式会社    | 令和4年度改修対応（8月リリース）
// 01.02.00 | 2022/09/14 | 富士通Japan株式会社    | 令和4年度改修対応（2次リリース）
// 01.04.00 | 2023/04/20 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
// 01.05.00 | 2023/08/08 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__main">
		<caution-item
			v-bind:tyuibunItems="disp.systemTyuiItem"
		/>
		<br />
		<div v-if="form.userRole === ROLE_TYPE.IPPAN_RIYOUSYA">
			<!-- エラーメッセージ -->
			<error-message class="error-width" />
			<ul class="menu-ul">
				<li tabindex="1" class="menu-li">
					<a class="menu-button" @click="bosyuSearch">
						<font-awesome-icon icon="search" class="icon-size" />
						<br />
						<span>募集住宅検索</span>
					</a>
				</li>
				<li tabindex="2" class="menu-li">
					<a class="menu-button" @click="mousikomiKakunin">
						<font-awesome-icon :icon="['far', 'file-alt']" class="icon-size" />
						<br />
						<span>申込み確認</span>
					</a>
				</li>
				<li tabindex="3" class="menu-li li-PC">
					<a class="menu-button" @click="riyosyajohoHenko">
						<font-awesome-icon :icon="['fas', 'user-edit']" class="icon-size edit-margin" />
						<br />
						<span>利用者情報<br />確認・変更</span>
					</a>
				</li>
			</ul>
			<ul class="menu-ul">
				<li tabindex="3" class="menu-li li-mobile">
					<a class="menu-button" @click="riyosyajohoHenko">
						<font-awesome-icon :icon="['fas', 'user-edit']" class="icon-size edit-margin" />
						<br />
						<span>利用者情報<br />確認・変更</span>
					</a>
				</li>
			</ul>
			<div v-show="disp.delLinkActive">
				<div  v-if="disp.delLinkSumaho" :class="['div-del-transition-isErr', {'div-del-transition-mobile':disp.mobileFlg}]">
					利用者登録を削除される方は
					<a class="div-del-link" @click="riyosyasakujo">こちら</a>
				</div>
				<div v-else :class="['div-del-transition', {'div-del-transition-mobile':disp.mobileFlg}]">
					利用者登録を削除される方は
					<a class="div-del-link" @click="riyosyasakujo">こちら</a>
				</div>
			</div>
		</div>
		<div v-else>
			<error-message class="error-width" />
			<ul class="menu-ul">
				<li tabindex="1" class="menu-li">
					<a class="menu-button" @click="bosyuTorikomi">
						<font-awesome-icon icon="file-import" class="icon-csv" />
						<br />
						<span>募集住宅<br />取込み</span>
					</a>
				</li>
				<li tabindex="2" class="menu-li">
					<a class="menu-button" @click="riyousyaSearch">
						<font-awesome-icon :icon="['fas','user']" class="icon-size" />
						<font-awesome-icon :icon="['fas','search']" class="icon-size user-search-icon" />
						<br />
						<span>利用者検索</span>
					</a>
				</li>
				<li tabindex="3" class="menu-li">
					<a class="menu-button" @click="zyutakuzyokyoTorikomi">
						<font-awesome-icon icon="file-import" class="icon-csv2" />
						<span class="fa icon_layers_text">OCR</span>
						<br />
						<span>住宅状況<br />取込み</span>
					</a>
				</li>
			</ul>
			<span class="li-PC"><br /></span>
			<ul class="menu-ul">
				<li tabindex="4" class="menu-li">
					<a class="menu-button" @click="zuiziSearch">
						<font-awesome-icon :icon="['fas','home']" class="icon-size" />
						<font-awesome-icon :icon="['fas','search']" class="icon-size home-serch-icon" />
						<br />
						<span>随時募集住宅<br />管理</span>
					</a>
				</li>
				<li tabindex="5" class="menu-li">
					<a class="menu-button" @click="dairiMousikomi">
						<font-awesome-icon :icon="['far','file']" class="icon-size" />
						<font-awesome-icon :icon="['fas','pen']" class="icon-size pen-icon" />
						<br />
						<span>随時募集<br />代理申込み</span>
					</a>
				</li>
				<li tabindex="6" class="menu-li">
					<a class="menu-button" @click="mousikomiRireki">
						<font-awesome-icon :icon="['far', 'file-alt']" class="icon-size" />
						<br />
						<span>申込者<br />情報管理</span>
					</a>
				</li>
			</ul>
			<span class="li-PC"><br /><br /><br /><br /><br /><br /><br /><br /></span>
			<ul class="menu-ul">
				<li v-show="form.envJudgeFlg != 1" tabindex="8" class="menu-li">
					<a class="menu-button-kensyo" @click="kadoDateSetting">
						<font-awesome-icon :icon="['far','calendar']" class="icon-size" />
						<font-awesome-icon :icon="['fas','pen']" class="icon-size pen-calendar-icon" />
						<br />
						<span>稼働日付<br />設定</span>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import CautionItem from '@/components/CautionItem.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_errorDialog } from '@/common/dialogUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_isOperationStaff, co_isMobile } from '@/common/browserUtility.js'; 
import { co_toTrans } from '@/common/screenUtility.js';
import { co_isEmpty } from '@/common/checkUtility.js';

import { STORE_USER_GET_INFO, STORE_ERROR_SETMSG, STORE_ERROR_CLEAR, STORE_VIEW_PROGRESS,
			STORE_DATA_DELETE_ALL, STORE_VIEW_CLEAR_PAGE, STORE_VIEW_CLEAR_VIEW_PARAMS, STORE_ERROR_GET_ERRMSG } from '@/const/store.js';
import { NUMBERINPUT_TYPE, DIALOG_BUTTON_LIST_KEY, ROLE_TYPE, DATE_KIND } from '@/const/const.js';
import { PATH_BC002_ITIJIHOZON, PATH_BC002_ITIJIHOZONKANRI, PATH_BC002_SEARCH, PATH_BC002_KAKUNIN, PATH_BC002_SEARCH_ZUIJI } from '@/const/route.js';

export default {
	components: {
		'error-message': ErrorMessage,
		'caution-item': CautionItem,
	},
	data: function () {
		return {
			form: {
				userRole: "",
				kadoDate: '',	// 稼働日付
				envJudgeFlg: 0,	// 環境判定結果
			},
			disp: {
				systemTyuiItem: ['C0190'],		// システム注意文
				delLinkActive: true,			// 削除リンク表示制御フラグ
				delLinkSumaho: false,			// 削除リンク表示制御フラグ（スマホ用）
				mobileFlg : false,				// モバイル端末フラグ
			},
			NUMBERINPUT_TYPE: NUMBERINPUT_TYPE,
			ROLE_TYPE: ROLE_TYPE,
			DATE_KIND: DATE_KIND,
		};
	},
	created: async function() {

		let userInfo = this.$store.getters[STORE_USER_GET_INFO];
		this.form.userRole = userInfo.role;

		// ブラウザチェック
		if (this.form.userRole != ROLE_TYPE.IPPAN_RIYOUSYA) {
			if(!await co_isOperationStaff()) {
				co_toTrans('BrowserError');
			}
		}

		// エラークリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// データ存在チェック(利用者用)
		if (this.form.userRole == ROLE_TYPE.IPPAN_RIYOUSYA) {
			let itijihozonData = await co_post(PATH_BC002_ITIJIHOZON);
			// データが存在する場合、エラーメッセージ表示
			for(let i=0;i<itijihozonData.messageList.length;i++){
				if (itijihozonData.messageList[i].unyoDate != "") {
					this.$store.commit(STORE_ERROR_SETMSG, co_getMessage(itijihozonData.messageList[i].messageID, itijihozonData.messageList[i].unyoDate));
				} else {
					if (itijihozonData.messageList[i].nmBosyu != "") {
						this.$store.commit(STORE_ERROR_SETMSG, co_getMessage(itijihozonData.messageList[i].messageID, itijihozonData.messageList[i].nmBosyu));
					} else {
						this.$store.commit(STORE_ERROR_SETMSG, co_getMessage(itijihozonData.messageList[i].messageID));
					}
				}
			}
		}

		// 一時保存データ存在チェック(管理者用)
		if (this.form.userRole != ROLE_TYPE.IPPAN_RIYOUSYA) {
			let initDate = await co_post(PATH_BC002_ITIJIHOZONKANRI);
			// 一時保存データが存在する場合
			if (initDate.itijihozonKanri > 0) {
				// エラーメッセージ表示
				this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('I0025'));
			}
			
			// 環境判定
			if (initDate.envJudgeFlg == 1) {
				this.form.envJudgeFlg = 1;	// 1：本番環境、1以外：本番環境以外
			}
		}

		// 利用者情報削除リンク表示制御（スマホ用）
		if (co_isEmpty(this.$store.getters[STORE_ERROR_GET_ERRMSG])) {
			this.disp.delLinkSumaho = false;
		} else {
			this.disp.delLinkSumaho = true;
		}

		// モバイル有無
		this.disp.mobileFlg = await co_isMobile();

		// 画面保持情報クリア
		this.$store.commit(STORE_DATA_DELETE_ALL);
		this.$store.commit(STORE_VIEW_CLEAR_PAGE);
		this.$store.commit(STORE_VIEW_CLEAR_VIEW_PARAMS);

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);

	},
	mounted() {
		// 画面サイズ変更時
		window.addEventListener('resize', this.resizeWindow);
	},
	methods: {
		// 募集住宅有無検索
		bosyuSearch: async function () {
			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			let bosyuJyouhou = await co_post(PATH_BC002_SEARCH);

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			// 募集住宅が存在しない場合
			if (bosyuJyouhou === 0) {
				co_errorDialog(co_getMessage('E0003'), this.doBosyuJyouhou);
				return;
			} else {
				co_toTrans("BC005");
			}
		},
		// ダイアログ「OK」ボタン押下時処理
		doBosyuJyouhou: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return;
			}
		},
		// 申込情報有無検索
		mousikomiKakunin: async function () {
			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			let mousikomiJyouhou = await co_post(PATH_BC002_KAKUNIN);

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			// 申込情報の件数が存在しない場合
			if (mousikomiJyouhou === 0) {
				co_errorDialog(co_getMessage('E0009'), this.doMousikomiJyouhou);
				return;
			} else {
				co_toTrans("BC010");
			}
		},
		// ダイアログ「OK」ボタン押下時処理
		doMousikomiJyouhou: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return;
			}
		},
		// 利用者情報確認・変更画面へ遷移
		riyosyajohoHenko: function() {
			co_toTrans("BC017");
		},
		// 募集住宅情報CSV取込画面へ遷移
		bosyuTorikomi: function() {
			co_toTrans("BC012C1");
		},
		// 利用者情報検索画面へ遷移
		riyousyaSearch: function() {
			co_toTrans("BC015");
		},
		// 住宅状況情報取込み画面へ遷移
		zyutakuzyokyoTorikomi: function() {
			co_toTrans("BC013C1");
		},
		// 稼働日付設定画面へ遷移
		kadoDateSetting: function() {
			co_toTrans("BC090");
		},
		// 随時募集住宅検索画面へ遷移
		zuiziSearch: function() {
			co_toTrans("BC050");
		},
		// 随時募集代理申込み画面へ遷移
		dairiMousikomi: async function() {
			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			let zuijiBosyuJyouhou = await co_post(PATH_BC002_SEARCH_ZUIJI);

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			// 募集住宅が存在しない場合
			if (zuijiBosyuJyouhou === 0) {
				co_errorDialog(co_getMessage('E0003'), this.doDairiMousikomi);
				return;
			} else {
				co_toTrans("BC055");
			}
		},
		// ダイアログ「OK」ボタン押下時処理
		doDairiMousikomi: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return;
			}
		},
		// 申込み履歴検索画面へ遷移
		mousikomiRireki: function() {

			co_toTrans("BC060");

		},
		// 画面サイズ変更時
		resizeWindow(){
			const top = 550; // 利用者情報削除リンクの表示限界位置
			let height = window.innerHeight; // 画面高さを取得
			// 利用者情報削除リンク表示制御
			if (top <= height || this.disp.mobileFlg) {
				this.disp.delLinkActive = true;
			} else {
				this.disp.delLinkActive = false;
			}
		},
		// 利用者情報削除画面へ遷移
		riyosyasakujo: function () {
			co_toTrans("BC020");
		},
	},
};
</script>

<style scoped>
.div-tyuimargin {
	margin-left: 2%;
	margin-right: 2%;
}
.icon-size{
	font-size: 40px;
}
.icon-csv{
	font-size: 40px;
	margin-bottom: 7%;
}

.menu-ul {
	display: flex !important;
	margin-right: auto;
	margin-left: auto;
	width: auto !important;
	list-style: none;
}
.div-del-link {
	color: #0000EE;
	cursor: pointer;
	text-decoration: underline !important;
}
.div-del-link:hover {
	color: #0000EE;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.menu-ul {
		margin-right: auto;
		margin-left: 0px;
	}
	.menu-li {
		margin-left: 30px;
	}
	.menu-button {
		display: inline-block;
		border-radius: 25px; /* 角丸 */
		font-size: 16pt; /* 文字サイズ */
		text-align: center; /* 文字位置 */
		cursor: pointer; /* カーソル */
		padding: 12px 30px; /* 余白 */
		background: #eeeeee; /* 背景色 */
		color: #000000; /* 文字色 */
		line-height: 1em; /* 1行の高さ */
		transition: 0.1s; /* なめらか変化 */
		border: 2px solid #000000; /* 枠の指定 */
		text-decoration: none;
		/* margin-left: 30px; */
		height: 98px;
		width: 128px;
		position: relative;
	}
	.menu-button-kensyo {
		display: inline-block;
		border-radius: 25px; /* 角丸 */
		font-size: 16pt; /* 文字サイズ */
		text-align: center; /* 文字位置 */
		cursor: pointer; /* カーソル */
		padding: 12px 30px; /* 余白 */
		background: #EEEEEE; /* 背景色 */
		color: #58257F; /* 文字色 */
		line-height: 1em; /* 1行の高さ */
		transition: 0.1s; /* なめらか変化 */
		border: 2px solid #58257F; /* 枠の指定 */
		text-decoration: none;
		/* margin-left: 30px; */
		height: 98px;
		width: 128px;
		position: relative;
	}
	.label-tyuijikou {
		font-size: 20px;
		margin-left: 1%;
	}
	.menu-button:hover {
		background: #3b3b3b;
		color: #ffffff;
	}
	.menu-button-kensyo:hover {
		background: #58257F;
		color: #ffffff;
	}
	.fa-search {
		margin-bottom: 10px;
	}
	.fa-file-alt {
		margin-bottom: 10px;
	}
	.li-mobile {
		display: none;
	}
	.fa-user-edit {
		margin-bottom: 10px;
	}
	.edit-margin {
		margin-left: 10px;
	}
	.div-tyuibunItem {
		font-size: 19.6506px;
		margin-left: 3%;
	}
	.error-width {
		width: 94%;
	}
	.fa-file {
		margin-bottom: 10px;
	}
	.fa-home {
		margin-bottom: 10px;
	}
	.fa-user {
		margin-bottom: 10px;
	}
	.fa-calendar {
		margin-bottom: 10px;
	}
	.home-serch-icon {
		width: 29px;
		height: 23px;
		background-color: #EEE;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 20px;
		cursor: pointer;
		position: absolute;
		top: 32px;
		left: 96px;
		font-size: 23px;
		padding: 2px 0px 0px 0px;
	}
	.user-search-icon {
		width: 28px;
		height: 23px;
		background-color: #EEE;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 20px;
		cursor: pointer;
		position: absolute;
		top: 34px;
		left: 96px;
		font-size: 23px;
		padding: 2px 0px 0px 0px;
	}
	.pen-icon {
		width: 17px;
		height: 18px;
		background-color: #EEE;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 20px;
		cursor: pointer;
		position: absolute;
		top: 27px;
		left: 87px;
		font-size: 18px;
	}
	.icon-csv2{
		font-size: 40px;
		margin-bottom: 7%;
		margin-left: 35px;
	}
	.icon_layers_text{
		position: absolute;
		top: 25px;
		left: 55px;
		color: black;
		font-size: 11px;
		font-weight: bold;
		background-color: ghostwhite;
		border: solid 3.5px;
		padding-left: 4px;
		padding-right: 4px;
		height: 18px;
	}
	.pen-calendar-icon {
		width: 17px;
		height: 18px;
		background-color: #EEEEEE;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 20px;
		cursor: pointer;
		position: absolute;
		top: 27px;
		left: 86px;
		font-size: 18px;
	}
	.menu-button:hover .user-search-icon {
		background: #3b3b3b;
	}
	.menu-button:hover .home-gear-icon {
		background: #3b3b3b;
	}
	.menu-button:hover .home-serch-icon {
		background: #3b3b3b;
	}
	.menu-button:hover .pen-icon {
		background: #3b3b3b;
	}
	.menu-button:hover .icon_layers_text {
		background: #3b3b3b;
		color: #fff;
	}
	.menu-button-kensyo:hover .pen-calendar-icon {
		background: #58257F;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.menu-ul {
		margin-right: auto;
		margin-left: auto;
	}
	.menu-li {
		margin-left: 20px;
	}
	.menu-button {
		display: inline-block;
		border-radius: 25px; /* 角丸 */
		font-size: 14pt; /* 文字サイズ */
		text-align: center; /* 文字位置 */
		cursor: pointer; /* カーソル */
		padding: 12px 12px; /* 余白 */
		background: #eeeeee; /* 背景色 */
		color: #000000; /* 文字色 */
		line-height: 1em; /* 1行の高さ */
		transition: 0.1s; /* なめらか変化 */
		border: 2px solid #000000; /* 枠の指定 */
		height: 98px;
		width: 120px;
	}
	.menu-button-kensyo {
		display: inline-block;
		border-radius: 25px; /* 角丸 */
		font-size: 14pt; /* 文字サイズ */
		text-align: center; /* 文字位置 */
		cursor: pointer; /* カーソル */
		padding: 12px 12px; /* 余白 */
		background: #EEEEEE; /* 背景色 */
		color: #58257F; /* 文字色 */
		line-height: 1em; /* 1行の高さ */
		transition: 0.1s; /* なめらか変化 */
		border: 2px solid #58257F; /* 枠の指定 */
		height: 98px;
		width: 120px;
	}
	a {
		text-decoration: none;
		/* margin-left: 31px; */
	}
	.label-tyuijikou {
		font-size: 18px;
		margin-left: 1%;
	}
	a:hover {
		color: #ffffff;
	}
	.menu-button:hover {
		background: #3b3b3b;
	}
	.menu-button-kensyo:hover {
		background: #58257F;
		color: #ffffff;
	}
	.fa-search {
		margin-bottom: 10px;
	}
	.fa-file-alt {
		margin-bottom: 10px;
	}
	.li-PC {
		display: none;
	}
	.li-mobile {
		margin-top: 25px;
	}
	.fa-user-edit {
		margin-bottom: 10px;
	}
	.edit-margin {
		margin-left: 10px;
	}
	.div-tyuibunItem {
		font-size: 21.8341px;
		margin-top: 15px;
	}
	.icon-csv2{
		font-size: 40px;
	}
}
/* 端末がPCの場合 */
@media screen and (min-width: 1080px) {
	.div-del-transition {
		position: fixed;
		bottom: 3vh;
		transform: translateX(235%);
	}
	.div-del-transition-isErr {
		position: fixed;
		bottom: 3vh;
		transform: translateX(235%);
	}
}

@media screen and (max-width: 1079px) and (min-width: 769px){
	.div-del-transition {
			position: fixed;
		bottom: 19px;
		right: 10px;
	}
	.div-del-transition-isErr {
		position: fixed;
		bottom: 19px;
		right: 10px;
	}
}

/** 端末がスマホの場合（横向き）解像度768px以上 */
@media (orientation: landscape) and (min-width: 768px) {
	.div-del-transition-mobile {
		/* right: 2%; */
		transform: none !important;
		position: relative !important;
		bottom: 0vh;
		text-align: right;
		margin-right: 13px;
		margin-bottom: 1%;
		margin-top: 5%;
	}
}

/** 端末がスマホの場合（縦向き）解像度768px以下 */
@media (orientation: portrait) and (max-width: 767px) {
	.div-del-transition {
		position: fixed;
		bottom: 2vh;
		right: 2vh;
		padding-bottom: 15px;
	}
	.div-del-transition-isErr {
		position: absolute;
		bottom: -10vh;
		right: 2vh;
		padding-bottom: 15px;
	}
}

/** 端末がスマホの場合（横向き）解像度768px以下 */
@media (orientation: landscape) and (max-width: 767px) {
	.div-del-transition-isErr {
		text-align: right;
		margin-right: 13px;
		margin-bottom: 5px;
	}

	.div-del-transition {
		text-align: right;
		margin-right: 13px;
		margin-bottom: 5px;
	}
}
</style>